import { exportFormattedTableExcel } from './formattedExcelExport';

export async function exportAsExcel(columns, records, filename = 'export', options = {}) {
  await exportFormattedTableExcel(columns, records, filename, options);
}
